import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import { getMonthDayFullYear } from 'helpers/DateUtil'
import Schedule from 'components/fulcrum/schedule/Schedule'
import {
  SCHEDULE_FILTER
} from 'containers/Project/ScheduleSection/constants'
import { disabledByDefault } from './constants'
import { 
  updateProjectScheduleChangeDate, 
  updateProjectScheduleChangeDateInput,
  updateProjectScheduleChangeToggleEnabled
} from './actions'

import { 
  projectScheduleChangeSelector
} from './selectors'
import { Flex } from 'reflexbox'
import Switch from 'react-toolbox/lib/switch';
import notifyHoc from 'containers/App/Notification/Notify'
import {
  segmentSelector
} from 'containers/Project/OverviewSidebar/selectors'
import {
  segmentSelector as segmentSelectorFromDetails
} from 'containers/Project/View/selectors'
const InfoSwitch = notifyHoc(Switch)

const mapStateToProps = state => {
    return {
      projectScheduleChange: projectScheduleChangeSelector(state),
      segment: segmentSelector(state),
      segmentFromDetails: segmentSelectorFromDetails(state)
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      updateProjectScheduleChangeDate: (param, date) => dispatch(updateProjectScheduleChangeDate(param, date)),
      updateProjectScheduleChangeDateInput: (param, dateInput) => dispatch(updateProjectScheduleChangeDateInput(param, dateInput)),
      updateProjectScheduleChangeToggleEnabled: (param) => dispatch(updateProjectScheduleChangeToggleEnabled(param))
    }
  }

class ScheduleEdit extends Component {

  render(){
    const {
      segment,
      segmentFromDetails,
      onCreate,
      projectScheduleChange,
      updateProjectScheduleChangeDate,
      updateProjectScheduleChangeDateInput,
      updateProjectScheduleChangeToggleEnabled,
    } = this.props;

    let order = []
    if (segment) order = SCHEDULE_FILTER.find(({segment : s}) => s === segment).schedules
    if (segmentFromDetails) order = SCHEDULE_FILTER.find(({segment : s}) => s === segmentFromDetails).schedules
    if (onCreate && segment === 'Enterprise') order = order.filter(schedule => !disabledByDefault.includes(schedule))

    return (
      <div styleName='schedule_edit'>
        {order.map((property, index) => {
          return (
            <Flex styleName='schedule_date_container' key={index}>
              <InfoSwitch
                styleName='schedule_switch'
                checked={projectScheduleChange[property].enabled}
                onChange={() => updateProjectScheduleChangeToggleEnabled(property)}
                message={T.translate('project.schedule.switchTooltip')}
              />
              <Schedule
                minDate={new Date()}
                label={T.translate('project.schedule.elements.' + property)}
                input={projectScheduleChange[property].dateInput}
                dateInput={Date.parse(projectScheduleChange[property].date) ? new Date(projectScheduleChange[property].date) : undefined}
                onInputChange={(newInput) => {updateProjectScheduleChangeDateInput(property, newInput)}}
                onDateChange={(newDate) => {updateProjectScheduleChangeDate(property, getMonthDayFullYear(new Date(newDate)))}}
                disabled={!projectScheduleChange[property].enabled}
              />
            </Flex>
          )
        })}
      </div>
    );
  }
    
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(ScheduleEdit);